import React from 'react';
import { Menu } from 'primereact/menu';

function PrimeReactMenu(props) {
  const { menuModel = [], isPopup = true, menuRef = null, menuId = '', ...rest } = props || {};
  return (
    <div>
      <Menu model={menuModel} ref={menuRef} id={menuId} popup={isPopup} {...rest} />
    </div>
  );
}

export default PrimeReactMenu;
